
export const SET_REGION_LIST = 'SET_REGION_LIST'
export const REMOVE_REGION_LIST = 'REMOVE_REGION_LIST'